import { Button, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, useDisclosure, useToast } from "@chakra-ui/react";
import React from "react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


function User_crud({ tittle, setFetchAgain }) {

    const { isOpen, onOpen, onClose } = useDisclosure()


    const toast = useToast();
    const [name, setName] = useState("");
    const [username, setusername] = useState("");
    const [password, setPassword] = useState('');
    const [authorized, setAuthorized] = useState(true);
    const [picLoading, setPicLoading] = useState(true);



    const { user } = ChatState();

    const openModal = () => {
        setName("");
        setusername("");
        setPassword('');
        setAuthorized(true);
        setPicLoading(false);
        onOpen()
    }
    const registerUser = async () => {

        if (!name || !username || !password || !authorized) {
            toast({
                title: "Veuillez remplir tous les champs",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });
            setPicLoading(false);
            return;
        }

        try {
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            };
            await axios.post(
                "/api/user",
                {
                    name,
                    username,
                    password,
                    authorized,
                },
                config
            );
            toast({
                title: "Inscription réussie",
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });


            setFetchAgain(true);
        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: error.response.data.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

        }
        onClose()
    };






    // const postDetails = (pics) => {
    //     setPicLoading(true);
    //     if (pics === undefined) {
    //         toast({
    //             title: "Please Select an Image!",
    //             status: "warning",
    //             duration: 5000,
    //             isClosable: true,
    //             position: "bottom",
    //         });
    //         return;
    //     }

    //     if (pics.type === "image/jpeg" || pics.type === "image/png") {
    //         const data = new FormData();
    //         data.append("file", pics);
    //         data.append("upload_preset", "chat-app");
    //         data.append("cloud_name", "piyushproj");
    //         fetch("https://api.cloudinary.com/v1_1/piyushproj/image/upload", {
    //             method: "post",
    //             body: data,
    //         })
    //             .then((res) => res.json())
    //             .then((data) => {
    //                 setPic(data.url.toString());
    //                 setPicLoading(false);
    //             })
    //             .catch((err) => {
    //                 console.log(err);
    //                 setPicLoading(false);
    //             });
    //     } else {
    //         toast({
    //             title: "Please Select an Image!",
    //             status: "warning",
    //             duration: 5000,
    //             isClosable: true,
    //             position: "bottom",
    //         });
    //         setPicLoading(false);
    //         return;
    //     }
    // };

    return <>
        <Button bg='gray.50' className="p-2"  onClick={() => { openModal() }}><i className="fa-solid fa-plus text-blue-400 mx-2"></i> Nouvel user	</Button>
        <Modal

            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent m='auto'>
                <ModalHeader>{tittle === 'Add' ? 'Konto erstellen' : 'Konto bearbeiten'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>

                    <FormControl mt={2}>
                        <Input id='name' placeholder='Nom' value={name}
                            onChange={(e) => setName(e.target.value)} />
                    </FormControl>
                    <FormControl mt={4}>
                        <Input placeholder='Username' id='username' value={username}
                            onChange={(e) => setusername(e.target.value)} />
                    </FormControl>
                    <FormControl mt={4}>
                        <Input placeholder='mot de passe' id='password'
                            onChange={(e) => setPassword(e.target.value)} />
                    </FormControl>
                    <FormControl mt={4} display='flex' alignItems='center'>
                        <FormLabel htmlFor='authorized' mb='0'>
                        Activer/Arrêter d'utiliser l'application
                        </FormLabel>
                        <Switch id='authorized' defaultChecked={authorized}
                            onChange={(e) => setAuthorized(e.target.checked)} />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='blue' mr={3}
                        onClick={registerUser}
                        isLoading={picLoading}>
                        Enregistrer
                    </Button>
                    <Button onClick={onClose}>Annuler</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </>
}

export default User_crud